import { Injectable } from '@angular/core';
import { OpenApiDataSource, RxapOpenApiDataSource } from 'eurogard-open-api-data-source';
import { UserControllerGetWebauthnRegisterPasswordlessParameter } from '../parameters/user-controller-get-webauthn-register-passwordless.parameter';
import { UserControllerGetWebauthnRegisterPasswordlessResponse } from '../responses/user-controller-get-webauthn-register-passwordless.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiDataSource('user-controller-getWebauthnRegisterPasswordless')
export class UserControllerGetWebauthnRegisterPasswordlessDataSource extends OpenApiDataSource<UserControllerGetWebauthnRegisterPasswordlessResponse, UserControllerGetWebauthnRegisterPasswordlessParameter> {
}
